'use strict';
var $ = jQuery;

var _calc = {

	init: function () {
		_calc.setHpcCalc();
		_calc.setSpcCalc();
	},

	runSpcCalc: function(formEls){
		var $results = formEls.form.find('.results'),
		result1=0,result2=0, pres = parseFloat(formEls.sp.val()),
		cd = formEls.cd.val(),khe = formEls.khe.val(), lod = parseFloat(formEls.lod.val()), nof = parseFloat(formEls.nof.val()), khep = parseFloat(formEls.khep.val()), inputError = false;

		//console.log(cd+'--'+ch+'--'+pres);
		//if((!cd && !ch) || (!cd && !pres)|| (!ch && !pres)) return false;

		result1 = pres;
		if(result1){
			if (cd == "Ducted") {
				console.log('lod:' + lod);
				if (lod > 0)
					result1 = (result1 / 100) * lod;
				else{
					formEls.lod.addClass("error");
					inputError = true;
				}
			}
		}
		else inputError = true;

		result2 = nof * 0.08;
		if(result2){
			if (khe == "Yes") {
				console.log('khep:' + khep);
				if (khep > 0)
					result2 = result2 + khep;
				else{
					formEls.khep.addClass("error");
					inputError = true;
				}
			}
		}
		else inputError = true;

		if(!inputError){
			var result3 = result1 + result2;
			$results.html('<div>Total Pressure due to Ductwork is equal to <strong>' + result1.toFixed(2) + ' inches</strong>.<br/>Pressure from Fittings and other Elements is equal to <strong>' + result2.toFixed(2) + ' inches</strong>.</div>'+'<div class="bigger">Total Pressure is equal to <strong>' + result3.toFixed(2) + ' inches</strong>.</div>');
		}
		else $results.html("");

	},
	setSpcCalc: function(){
		var formEls = {
			form: $("#spcCalc"),
			cd  : $('#calcDuctwork'),
			lod : $('#calcLengthOfDuct'),
			sp  : $('#calcStaticPressure'),
			nof : $('#calcNumberOfFittings'),
			khe : $('#calcKhe'),
			khep: $('#calcKhePressure')
		};
		$.validator.addMethod("digitsonly", function(value, element) {
			return this.optional(element) || /^[0-9.]+$/i.test(value);
		}, "Digits only");
		formEls.lod.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
		formEls.sp.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
		formEls.nof.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
		formEls.khep.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
		$('#calcDuctwork').on('change',function(){
			if ($(this).val() == "Ducted") {
				$("#calcLengthOfDuct").show().prev().show();
			}
			else {
				$("#calcLengthOfDuct").hide().prev().hide();
			}
		});$('#calcDuctwork').trigger('change');
		$('#calcKhe').on('change',function(){
			if ($(this).val() == "Yes") {
				$("#calcKhePressure").show().prev().show();
			}
			else {
				$("#calcKhePressure").hide().prev().hide();
			}
		});$('#calcKhe').trigger('change');
		formEls.form.validate({
			rules: {
				"calcLengthOfDuct": {
					digitsonly: true
				},
				"calcStaticPressure": {
					digitsonly: true,
					required: true
				},
				"calcNumberOfFittings": {
					digitsonly: true,
					required: true
				},
				"calcKhePressure": {
					digitsonly: true
				}
			},
			submitHandler: function(form) {
				_calc.runSpcCalc(formEls);
				return false;
			}
		});
	},
	runHpcCalc: function(formEls){
		var result=0, pres = parseFloat(formEls.pres.val()),
		cd = parseFloat(formEls.cd.val()), ch = parseFloat(formEls.ch.val());
		console.log(cd+'--'+ch+'--'+pres);
		if((!cd && !ch) || (!cd && !pres)|| (!ch && !pres)) return false;
		if(!cd){
			result = (pres * 47.8803) / 9.8066 / (ch / 3.281 ) / 16.018;
			formEls.cd.val(result.toFixed(2));
			//console.log('cd');
		}
		else if(!ch){
			result = (pres * 47.8803) * 3.281 / 9.8066 / (cd * 16.018);
			formEls.ch.val(result.toFixed(2));
			//console.log('ch');
		}
		else {
			result = (cd * 16.018) * 9.8066 * (ch / 3.281) / 47.8803;
			formEls.pres.val(result.toFixed(2));
			//console.log('pres');
		}
	},
	setHpcCalc: function(){
		var formEls = {
			form: $("#hpcCalc"),
			cd  : $('#calcDensity'),
			ch  : $('#calcHeight'),
			pres: $('#calcPressure')
		};
		$.validator.addMethod("digitsonly", function(value, element) {
			return this.optional(element) || /^[0-9.]+$/i.test(value);
		}, "Digits only");
		formEls.cd.mask('ZZZZZZZZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
		formEls.ch.mask('ZZZZZZZZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
		formEls.pres.mask('ZZZZZZZZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
		$('#calcFluid').on('change',function(){
			if ($(this).val() != "") {
				var valConvert = parseFloat($(this).val()) / 16.018; /*kg/m3 -> lbf/ft3*/
				$("#calcDensity").val(valConvert);
			}
		});$('#calcFluid').trigger('change');
		$('#calcDensity').on('keyup',function(){
			$('#calcFluid').val("");
		});

		formEls.form.validate({
			rules: {
				"calcDensity": {
					digitsonly: true
				},
				"calcHeight": {
					digitsonly: true
				},
				"calcPressure": {
					digitsonly: true
				}
			},
			submitHandler: function(form) {
				_calc.runHpcCalc(formEls);
				return false;
			}
		});
	}
};

$(document).ready(_calc.init);